import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { gql, useApolloClient, useReactiveVar } from "@apollo/client";
import TitleBar, { WithfriendsAction } from "./WithfriendsTitleBar";
import RedemptionBenefit from "./RedemptionBenefit";
import { currentBusinessIdVar, currentSubscriptionBenefitVar, dummyFunc } from "../helpers/client";
// @ts-ignore
import { useNavigate, useMatch } from "react-router-dom";
gql `
query RedemptionBenefitMembershipTierInfo($id: ID!) {
  benefit(id: $id){
    ... on RedemptionBenefit {
      id
      name
      membershipTiers {
        id
        name
      }
    }
  }
}
`;
const EditRedemptionBenefitScreen = ({ useSyncShopifyDataMutation = dummyFunc }) => {
    const navigate = useNavigate();
    const currentBusinessId = useReactiveVar(currentBusinessIdVar);
    const client = useApolloClient();
    const isReady = () => {
        const tiers = client.readFragment({
            id: `Business:${currentBusinessId}`,
            fragment: gql `
        fragment SaveMemberships_Redemption on Business { id }
      `,
        });
        return !!tiers;
    };
    if (!isReady()) {
        navigate("/memberships");
        return null;
    }
    const match = useMatch(`/memberships/:id/redemption/:benefitId`);
    const membershipId = match.params.id;
    const benefitId = match.params.benefitId;
    useEffect(() => {
        if (benefitId)
            currentSubscriptionBenefitVar(benefitId);
    }, [benefitId]);
    return (_jsxs("div", { className: "w-full max-w-xl", children: [_jsx(TitleBar, { title: `Redemption Settings`, action: WithfriendsAction.Memberships, primaryAction: WithfriendsAction.SaveRedemptionBenefit, crumbs: [WithfriendsAction.Memberships], useSyncShopifyDataMutation: useSyncShopifyDataMutation }), _jsx(RedemptionBenefit, { id: benefitId })] }));
};
export default EditRedemptionBenefitScreen;
